import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/produtos-nao-vinculados/')({
  beforeLoad: () => {
    return redirect({ to: '/vinculos-mapa' });
  },
});
